   /**
   * Function to get the most popular tour categories based on the tours data.
   * @param {Array} tours - The array of tour objects.
   * @returns {Array} - An array of the top 6 categories with their count, image, and index.
   */

 export const getPopularTourCategories = (tours) => {

    const categoryCount = {}; // Object to store the count of each tour type
    const categoryImage = {}; // Object to store an image for each tour type

    // Count occurrences of each tourType and store an image
    tours.forEach((tour) => {
        const category = tour.details.tourType; // Get the tour type (category)
        categoryCount[category] = (categoryCount[category] || 0) + 1; // Increment count for the category
        if (!categoryImage[category]) categoryImage[category] = tour.image; // Store first tour's image
    });

    // Convert to an array, sort by count (descending), and take the top 6
    return Object.entries(categoryCount)
      .sort((a, b) => b[1] - a[1])
      .map(([category, count], index) => ({
          index: index + 1, // Add index (1-based)
          category,
          count,
          image: categoryImage[category],
      }));
  };